<template>
  <EditMode
    v-if="isEditMode || disabled"
    :initialTime="initialTime"
    :label="label"
    :initialTimeUnit="initialTimeUnit"
    :disabled="disabled"
    :timeUnitOptions="monthly ? availableTimeUnitsPerMonth : availableTimeUnits"
    @update="update"
  />
  <ViewMode
    v-else
    :time="initialTime"
    :timeUnit="initialTimeUnit"
    :monthly="monthly"
    :label="label"
    :title="title"
    :isImpactValidated="isImpactValidated"
  />
</template>
<script>
import moment from 'moment'
import { utils } from 'frontend-js-shared'
import ViewMode from '@/components/Rev/Review/TimeImpact/ViewMode.vue'
import EditMode from '@/components/Rev/Review/TimeImpact/EditMode.vue'
import constants from '@/components/Rev/Review/TimeImpact/constants.js'

export default {
  name: 'TimeImpact',

  components: {
    ViewMode,
    EditMode,
  },

  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    milliseconds: {
      type: Number,
      required: false,
    },
    monthly: {
      type: Boolean,
      required: false,
      default: false,
    },
    isImpactValidated: Boolean,
  },

  data() {
    return {
      availableTimeUnitsPerMonth: [],
      availableTimeUnits: [],
      initialTime: null,
      initialTimeUnit: null,
      constants,
    }
  },

  watch: {
    isEditMode(isEditMode) {
      if (!isEditMode) {
        this.initialTimeUnit = utils.dates.getMillisecondsAsUnit(
          this.milliseconds
        )
        if (this.milliseconds !== null) {
          this.initialTime = utils.dates.getClosestRoundedTimeUnit(
            this.initialTimeUnit,
            this.milliseconds
          )
        }
      }
    },

    milliseconds() {
      if (!this.isEditMode)
        this.initialTimeUnit = utils.dates.getMillisecondsAsUnit(
          this.milliseconds
        )
      this.initialTime = utils.dates.getClosestRoundedTimeUnit(
        this.initialTimeUnit,
        this.milliseconds
      )
    },
  },

  mounted() {
    this.initialTimeUnit = utils.dates.getMillisecondsAsUnit(this.milliseconds)
    if (this.milliseconds !== null) {
      this.initialTime = utils.dates.getClosestRoundedTimeUnit(
        this.initialTimeUnit,
        this.milliseconds
      )
    }
    this.availableTimeUnitsPerMonth = [
      {
        text: this.$t('rev.time_tracking.units.mins_month'),
        value: this.constants.timeUnits.minute,
      },
      {
        text: this.$t('rev.time_tracking.units.hours_month'),
        value: this.constants.timeUnits.hour,
      },
      {
        text: this.$t('rev.time_tracking.units.days_month'),
        value: this.constants.timeUnits.day,
      },
      {
        text: this.$t('rev.time_tracking.units.weeks_month'),
        value: this.constants.timeUnits.week,
      },
    ]
    this.availableTimeUnits = [
      {
        text: this.$t('rev.time_tracking.units.mins'),
        value: this.constants.timeUnits.minute,
      },
      {
        text: this.$t('rev.time_tracking.units.hours'),
        value: this.constants.timeUnits.hour,
      },
      {
        text: this.$t('rev.time_tracking.units.days'),
        value: this.constants.timeUnits.day,
      },
      {
        text: this.$t('rev.time_tracking.units.weeks'),
        value: this.constants.timeUnits.week,
      },
    ]
  },

  computed: {
    label() {
      return this.monthly
        ? this.$t('rev.time_tracking.how_much_time_did_you_save')
        : this.$t('rev.time_tracking.how_much_time_did_you_invest')
    },

    title() {
      return this.monthly
        ? this.$t('rev.time_tracking.time_reduction')
        : this.$t('rev.time_tracking.time_investment')
    },
  },

  methods: {
    getMilliseconds(time, timeUnit) {
      if (time === '') return null
      const milliseconds = moment.duration(time, timeUnit).asMilliseconds()
      return milliseconds >= 0 ? milliseconds : null
    },

    update({ time, timeUnit }) {
      this.initialTimeUnit = timeUnit
      const milliseconds = this.getMilliseconds(time, timeUnit)
      this.$emit('update', milliseconds)
    },
  },
}
</script>
